/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {InvoiceItemDTO} from './invoice-item-dto.model';

export class InvoiceServiceItemDTO extends InvoiceItemDTO {

  serviceName: string | undefined = undefined;
  serviceType: string | undefined = undefined;
  operationType: string | undefined = undefined;
  vatExemptionReason: string | null | undefined = undefined;

}
